import React, {  useEffect, useState } from 'react';
import { useCurrentRefinements, useRefinementList } from 'react-instantsearch-hooks-web';
import { FacetProps } from './types';
import useRefinementHelpers from '../../hooks/useRefinementHelpers';
import { useProductList } from '../../../product-list-algolia/context';
import useTouchDevice from 'helpers/hooks/useTouchDevice';

const TermFacet: React.FC<FacetProps> = ({ attribute }) => {
  const { refine, items } = useRefinementList({ attribute, limit: 999, sortBy: ['name'] });
  const { resolveLabel } = useRefinementHelpers();
  const { removeAllRefinements } = useProductList();
  const { isTouchDevice } = useTouchDevice();

  const { items: currentRefinements } = useCurrentRefinements();
  const [noRefinement, setNoRefinement] = useState(true);
useEffect(()=>{
    if(currentRefinements.length===0){
        setNoRefinement(true)

    }
    
}, [currentRefinements])
  return (
    <div>
      <div className="flex flex-row flex-wrap justify-start md:justify-center gap-12  lg:min-w-[20rem]">
        <div
            onClick={() => {
              removeAllRefinements();
            }}
            className={`rounded-full border border-gray-700 hover:xl:cursor-pointer ${
              noRefinement ? 'bg-gray-700 text-white' : 'bg-transparent text-primary-black'
            } px-16 py-10 text-12 transition ${!isTouchDevice && 'hover:bg-gray-700 hover:text-white' } 2xl:py-12 2xl:text-16`}
          >
            All
          </div>
        {items.map((term) => (
          <div
            onClick={() => {
              setNoRefinement(false);
              refine(term.value);
            }}
            key={term.value}
            className="flex items-center justify-start hover:xl:cursor-pointer"
          >
            <div
              className={`rounded-full border border-gray-700 ${
                term.isRefined ? 'bg-gray-700 text-white' : 'bg-transparent text-primary-black'
              }  px-16 py-10 text-12 transition ${!isTouchDevice && 'hover:bg-gray-700 hover:text-white' } 2xl:py-12 2xl:text-16`}
            >
              {resolveLabel(attribute, term.label)?.split('>')?.pop()}
            </div>
            <div className="flex items-center gap-12"></div>
          </div>
        ))}

        
      </div>
    </div>
  );
};

export default TermFacet;
